export class Mergedview {
    mergedBins: any;
    mergedBinId: string;
    parentId: string;
}

